<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UehEx6/tc-custom/9781612006161.jpg?1716906352647" alt="This image is the cover for the book Amphibious Warfare, Casemate Short History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amphibious Warfare, Casemate Short History
      </h1>
      <p class="bookDescription body article font2">
        <b>“An easily accessible short history” of offensive military operations on hostile shores from the authors of <i>First to Fight: The U.S. Marines in World War I</i> (<i>Midwest Book Review</i>).</b><br/>  <br/> One of the most difficult types of warfare to master, landing on a hostile beach requires scrupulous planning and intense coordination between the air, sea, and land forces.<br/>  <br/> With a history reaching back to the Persians landing on the Greek shores at the Battle of Marathon in 490 BC, it was the First World War that marked the beginning of modern amphibious warfare, with the Royal Marines combining their efforts with the Royal Navy. Despite the disastrous Gallipoli amphibious operation to seize the Dardanelles Straits in 1915, the Royal Navy and US Marine Corps continued to develop new landing crafts through the interwar years. The Second World War proved more successful for amphibious warfare, with the Japanese invasion of the Philippines in 1941 crushing the American forces defending the Pacific islands and the D-Day landings by the Allied troops in 1944 initiating the beginning of the end of the war in Europe.<br/>  <br/> This accessible short history looks at the historical development of amphibious warfare, telling the stories of particular landings and the units that have taken part in this unique type of warfare. The Royal Marines and US Marine Corps continue to evolve and play a crucial role in defense today, with specialized amphibious warfare ships being deployed to enable elite forces to respond promptly to threats across the globe.<br/><br/> “A brief but very useful overview of an important aspect of modern warfare.” —<i>Baird Maritime</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Oscar E. Gilbert, Romain V. Cansière
      </h2>
      
      <p class="authorDescription body article">Oscar E. “Ed” Gilbert Jr. served as an artilleryman and NCO instructor in the Marine Corps Reserve before earning a Ph.D., working for the Geological Survey in Alabama, and teaching at Auburn University. He enjoyed a three-decade career in worldwide oil exploration. Ed was the author of many books, including Marine Corps Tank Battles in Korea (2006), and Marine Corps Tank Battles in Vietnam (2008). He was awarded the 2016 General Wallace M. Greene Jr. Award for Tanks in Hell: A Marine Corps Tank Company on Tarawa (2015). Ed passed away in February 2019.Romain V. Cansière is a native of southern France, interested in the U. S. Marine Corps since his teenage years. His current historical research is on the Marine Corps in World War I.Oscar and Romain co-authored Tanks In Hell: A Marine Corps Tank Company On Tarawa, winner of the 2016 General Wallace M. Greene Jr. Award for distinguished non-fiction.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?039cdf50